import { render, staticRenderFns } from "./SubstituteHolidayManage.vue?vue&type=template&id=000c0f2d"
import script from "./SubstituteHolidayManage.vue?vue&type=script&lang=js"
export * from "./SubstituteHolidayManage.vue?vue&type=script&lang=js"
import style0 from "./SubstituteHolidayManage.vue?vue&type=style&index=0&id=000c0f2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports